module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.currentMatrixChoice) ? _c('el-dialog', {
    attrs: {
      "title": "Select visibility condition",
      "width": "600px",
      "before-close": _vm.handleCancel,
      "visible": _vm.isVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.isVisible = $event
      }
    }
  }, [_c('p', {
    staticClass: "help-description"
  }, [_vm._v("\n    Only display the question\n    "), _c('strong', [_vm._v("\"" + _vm._s(_vm.currentMatrixChoice.title) + "\"")]), _vm._v(", once the user has selected a specific\n    choice from one of the following questions.\n  ")]), _vm._v(" "), _vm._l((_vm.availableMatrixChoices), function(matrixChoice) {
    return _c('div', {
      key: matrixChoice.id,
      staticClass: "matrix-item"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(matrixChoice.title))]), _vm._v(" "), _c('el-radio-group', {
      attrs: {
        "size": "mini"
      },
      model: {
        value: (_vm.currentMatrixChoice.visibleIf),
        callback: function($$v) {
          _vm.$set(_vm.currentMatrixChoice, "visibleIf", $$v)
        },
        expression: "currentMatrixChoice.visibleIf"
      }
    }, [_c('span', _vm._l((matrixChoice.choices), function(choice) {
      return _c('el-radio-button', {
        key: choice.id,
        attrs: {
          "label": ("{row.matrix" + (matrixChoice.id) + "}='" + (choice.title) + "'")
        }
      }, [_vm._v(_vm._s(choice.title))])
    }), 1)])], 1)
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "pull-left",
    attrs: {
      "disabled": !_vm.currentMatrixChoice,
      "type": "danger"
    },
    on: {
      "click": _vm.handleRemoveLinks
    }
  }, [_vm._v("Remove condition")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v("Save")])], 1)], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b5687616","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/surveybuilder/dialogs/MatrixConditionalLogicDialog.vue
// module id = 3383
// module chunks = 3